export function shorten(transactionHash) {
  if (typeof transactionHash !== "string" || transactionHash.length < 12) {
    return transactionHash;
  }

  const start = transactionHash.slice(0, 6);
  const end = transactionHash.slice(-6);

  return `${start} ••• ${end}`;
}

export function shortenMobile(transactionHash) {
  if (typeof transactionHash !== "string" || transactionHash.length < 12) {
    return transactionHash;
  }

  const start = transactionHash.slice(0, 6);
  const end = transactionHash.slice(-6);

  return `${start}...${end}`;
}

export function first36symbols(transactionHash) {
  if (typeof transactionHash !== "string" || transactionHash.length < 12) {
    return transactionHash;
  }

  return `${transactionHash.slice(0, 36)}...`;
}

export function first25symbols(transactionHash) {
  if (typeof transactionHash !== "string" || transactionHash.length < 12) {
    return transactionHash;
  }

  return `${transactionHash.slice(0, 25)}...`;
}
